import React from 'react'

const XIcon = () => (
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg"
	 viewBox="29 184 118 119">
    <g>
      <g>
        <path d="M100,243.41l44.426-44.425c3.279-3.279,3.279-8.592,0-11.871c-3.275-3.277-8.594-3.277-11.869,0L88.131,231.54
          l-44.426-44.426c-3.275-3.277-8.594-3.277-11.869,0c-3.279,3.279-3.279,8.592,0,11.871l44.426,44.425l-44.426,44.425
          c-3.279,3.279-3.279,8.592,0,11.871c1.637,1.638,3.787,2.458,5.934,2.458s4.297-0.82,5.934-2.458l44.426-44.426l44.426,44.426
          c1.637,1.638,3.787,2.458,5.934,2.458s4.297-0.82,5.934-2.458c3.279-3.279,3.279-8.592,0-11.871L100,243.41z" />
      </g>
    </g>
  </svg>
)

export default XIcon



// WEBPACK FOOTER //
// ./app/components/icons/XIcon.jsx